import { render, staticRenderFns } from "./mortgageToday.vue?vue&type=template&id=6bb4ba5c&scoped=true&lang=html&"
import script from "./mortgageToday.vue?vue&type=script&lang=js&"
export * from "./mortgageToday.vue?vue&type=script&lang=js&"
import style0 from "./mortgageToday.vue?vue&type=style&index=0&id=6bb4ba5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4ba5c",
  null
  
)

export default component.exports